// extracted by mini-css-extract-plugin
module.exports = {"pt-sign-notes-form":"pt-sign-notes-form-b39751f3eeef4c14ec4e1266f54e022c"};